import { useParams, Link } from "react-router-dom";
import { Truck, Car, Cog, Check, ArrowRight } from "lucide-react";
import { PublicNav, Footer } from "@/components/PublicLayout";

const DATA = {
  commercial: {
    icon: Truck, title: "Commercial & Heavy-Duty Maintenance",
    tagline: "Maximize uptime. Minimize surprises.",
    img: "https://images.unsplash.com/photo-1574757974346-45bae947d89a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
    intro: "Scheduled preventative maintenance programs for semis, box trucks and delivery fleets. Keep every vehicle DOT-compliant and on the road.",
    items: ["DOT & annual inspections", "Oil, filter & fluid PM service", "Air brake systems & ABS", "Tire, wheel & alignment service", "Engine diagnostics & aftertreatment", "Fleet PM scheduling & tracking"],
  },
  passenger: {
    icon: Car, title: "Passenger Vehicles",
    tagline: "Honest repairs for your daily driver.",
    img: "https://images.unsplash.com/photo-1615906655593-ad0386982a0f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
    intro: "From routine oil changes to major engine work, we keep your family vehicle safe and reliable with transparent, approve-what-you-want estimates.",
    items: ["Oil changes & tune-ups", "Brakes, rotors & suspension", "Timing belts & water pumps", "Check-engine diagnostics", "AC & heating service", "Batteries & electrical"],
  },
  custom: {
    icon: Cog, title: "Custom Builds",
    tagline: "Boats, ATVs, UTVs & lawn equipment.",
    img: "https://static.prod-images.emergentagent.com/jobs/1a9ea1bb-2c9c-4efc-8540-f074ca17f8fb/images/af6328a2144df1d165c2d330ddc649efc633a40e2eb4453cbd73eaa2995a69de.jpeg",
    intro: "Service, repair and custom work for your powersports, marine and outdoor equipment. If it has an engine, bring it in — we'll build you a clear estimate first.",
    items: ["Boats & marine engines — service & winterization", "ATVs — engine, drivetrain & suspension", "UTVs / side-by-sides — repairs & custom upgrades", "Lawn & garden equipment — mowers & small engines", "Custom fabrication & performance builds", "Seasonal tune-ups & storage prep"],
  },
};

export default function ServicePage() {
  const { category } = useParams();
  const d = DATA[category] || DATA.commercial;
  const Icon = d.icon;
  return (
    <div className="bg-[#09090b] min-h-screen">
      <PublicNav />
      <section className="relative grain">
        <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: `url('${d.img}')` }} />
        <div className="absolute inset-0 bg-black/75" />
        <div className="relative z-10 max-w-7xl mx-auto px-6 py-28">
          <Icon className="text-yellow-500 mb-4" size={40} />
          <p className="text-xs font-bold tracking-[0.3em] uppercase text-yellow-500 mb-3">{d.tagline}</p>
          <h1 className="font-display text-4xl lg:text-6xl font-black uppercase tracking-tighter max-w-3xl">{d.title}</h1>
        </div>
      </section>

      <section className="max-w-5xl mx-auto px-6 py-20">
        <p className="text-zinc-300 text-lg mb-12 max-w-3xl">{d.intro}</p>
        <div className="grid sm:grid-cols-2 gap-4 mb-14">
          {d.items.map((it) => (
            <div key={it} className="flex items-center gap-3 border border-zinc-800 bg-zinc-950 p-5" data-testid={`service-item-${category}`}>
              <span className="w-8 h-8 flex items-center justify-center bg-yellow-500 text-black flex-shrink-0"><Check size={16} /></span>
              <span className="text-zinc-200 font-medium">{it}</span>
            </div>
          ))}
        </div>
        <Link to="/request-quote" data-testid="service-request-quote"
          className="inline-flex items-center gap-2 bg-yellow-500 text-black font-bold uppercase px-8 py-4 hover:bg-yellow-300 transition-colors duration-150">
          Request a Quote <ArrowRight size={18} />
        </Link>
      </section>
      <Footer />
    </div>
  );
}
